import { BrandConfig } from './types';

/** The default identity: black and white, Inter + Outfit, Autopilotee policies. */
export const AUTOPILOTEE_BRAND: BrandConfig = {
  id: 'autopilotee',
  brandSite: 'autopilotee.com',
  name: 'Autopilotee Cars',
  siteTitle: 'AutoPilotee Cars',
  legalName: 'Jidosoju Holding Inc.',
  supportEmail: 'support@autopilotee.com',
  supportPhone: '+1(866)217-2849',
  policyBasePath: '/policies',
  assets: {
    favicon: '/favicon.ico',
    appleTouchIcon: '/logo192.png',
    manifest: '/manifest.json',
  },
  copy: {
    heroHeadline: 'Find Your Perfect Ride',
    heroSubcopy:
      'Discover the best cars from trusted local hosts. Book easily and hit the road with confidence.',
    about:
      "Autopilotee Cars is your premier destination for exceptional car rental experiences in the Bay Area. We specialize in providing high-quality vehicles that combine reliability, comfort, and style for every journey. Our extensive fleet features premium cars, spacious SUVs, elegant sedans, and powerful trucks, all meticulously maintained to ensure your safety and satisfaction. With transparent pricing, flexible booking options, and comprehensive protection plans, we make car rental simple, secure, and stress-free. Whether you're planning a weekend adventure, a business trip, or a special occasion, our dedicated team is committed to delivering personalized service that exceeds expectations. Experience the difference with Autopilotee Cars, where every rental is designed to elevate your travel experience.",
    metaDescription:
      'AutoPilotee Cars — Rent cars from trusted local hosts. Peer-to-peer car rental with flexible pickup, protection plans, and no hidden fees.',
    protectionDescription:
      'Choose a protection plan to protect you in the event of damage to a vehicle during a trip. Third-party liability protection for trips on Autopilotee Cars is arranged through Travelers Excess and Surplus Lines Company ("Travelers").',
  },
  theme: null,
  showStagingPlaceholderName: true,
};
